/**
 * Modalidades de entrenamiento.
 *
 * Los valores tienen que coincidir EXACTO con el enum del backend
 * (`be-coaching/src/common/enums/training-type.enum.ts`) y con las columnas
 * enum de la base (`client.trainingType`, `training_session.trainingType`,
 * `workout_instance.trainingType`), que guardan los literales en español.
 *
 * Estaban en inglés ('virtual_synchronous', 'hybrid'): valores que no existen
 * ni en la base ni en el backend, así que cualquier cosa tipada contra este
 * enum rechazaba los valores reales. Corregido junto con #36.
 */
export const ESessionMode = {
  PRESENTIAL: 'presencial',
  VIRTUAL_SYNCHRONOUS: 'virtual_sincronico',
  VIRTUAL_ASYNCHRONOUS: 'virtual_asincronico',
  HYBRID: 'hibrido'
} as const;

export type SessionMode = (typeof ESessionMode)[keyof typeof ESessionMode];

export const SESSION_MODES = Object.values(ESessionMode) as SessionMode[];
